import { apiFetch, HttpError } from '../http';
export const hasBookingBonusAllowance = (value) => {
    const data = value;
    return Boolean(data && Number.isFinite(data.booking_bonus_basic) &&
        Number.isFinite(data.exchange_cost) && data.exchange_cost > 0 && typeof data.can_exchange === 'boolean');
};
export function canExchangeBookingBonuses(allowance, target = 'advanced') {
    if (!allowance)
        return false;
    const cost = target === 'pro' ? allowance.pro_exchange_cost : allowance.exchange_cost;
    const eligible = target === 'pro' ? allowance.can_exchange_pro : allowance.can_exchange;
    return eligible === true && typeof cost === 'number' && Number.isFinite(cost) && cost > 0
        && Number.isFinite(allowance.basic_trips_allowed) && allowance.basic_trips_allowed > cost;
}
export function getBookingBonusAllowance(options) {
    return apiFetch('/user/api/user/travel_allowance/', {
        ...options, redirectOnUnauthorized: false,
    });
}
export async function exchangeBookingBonuses(options) {
    const response = await apiFetch('/user/api/user/booking_bonuses/exchange/', {
        baseUrl: options.baseUrl, token: options.token, method: 'POST', redirectOnUnauthorized: false,
        headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ request_id: options.requestId, ...(options.target ? { target: options.target } : {}) }),
    });
    if (response.success === false)
        throw new HttpError(200, response.error || 'Не удалось обменять бонусы.', response);
    if (!hasBookingBonusAllowance(response.travel_allowance))
        throw new Error('Не удалось получить баланс. Повторите запрос.');
    return response;
}
// Persist before sending: an interrupted request must not create a second exchange.
export function createBookingBonusExchange(storage) {
    const pending = new Map();
    return (owner, send) => {
        if (!owner)
            return Promise.reject(new Error('Войдите в аккаунт для обмена бонусов.'));
        const existing = pending.get(owner);
        if (existing)
            return existing;
        const key = `booking-bonus-exchange.${owner}`;
        const operation = (async () => {
            let requestId = await storage.read(key);
            if (!requestId) {
                requestId = storage.uuid();
                await storage.write(key, requestId);
            }
            try {
                const response = await send(requestId);
                await storage.remove(key);
                return response;
            }
            catch (error) {
                // Only definite validation failures can safely start a new operation.
                if (error instanceof HttpError && error.status === 400)
                    await storage.remove(key);
                throw error;
            }
        })().finally(() => pending.delete(owner));
        pending.set(owner, operation);
        return operation;
    };
}
const allowanceListeners = new Set();
export const notifyTravelAllowanceChanged = () => allowanceListeners.forEach(listener => listener());
export const onTravelAllowanceChanged = (listener) => {
    allowanceListeners.add(listener);
    return () => { allowanceListeners.delete(listener); };
};
export const BOOKING_BONUS_TITLE = 'Бронируйте и получайте путешествия';
export const BOOKING_BONUS_DESCRIPTION = 'За каждое подтверждённое бронирование по участвующей в программе ссылке TRACK.ME вы получите 2 бонусных базовых путешествия.';
export const BOOKING_BONUS_USAGE = 'Используйте бонусы для создания путешествий или обменяйте 3 базовых на 1 продвинутое или 10 базовых на 1 профи. Обмен — только по вашему желанию.';
export const BOOKING_BONUS_SETTINGS = 'Обмен производится в настройках аккаунта.';
export const BOOKING_BONUS_STEPS = [
    'Войдите в свой аккаунт TRACK.ME.',
    'Выберите предложение и нажмите «Перейти к бронированию».',
    'Оформите бронирование на сайте партнёра по открывшейся ссылке.',
    'Дождитесь подтверждения от партнёра. После обработки данных бонус появится в вашем аккаунте.',
];
export const BOOKING_BONUS_NOTICE = 'Один переход по ссылке бонуса не даёт. Одно подтверждённое бронирование учитывается один раз. Начисление не происходит мгновенно.';
export const BOOKING_BONUS_SCOPE = 'Программа действует только для участвующих ссылок с подтверждением бронирования через Travelpayouts, а не для всех сервисов.';
export const BOOKING_BONUS_EXCHANGE_SCOPE = 'Обменять можно доступные базовые путешествия, включая стартовые, купленные и бонусные. После обмена остаётся минимум одно базовое путешествие.';
